<template>
  <div id="job">
    <div class="job-top">
      <div class="wrap">
        <p class="job-date">[{{ jobData.createDateStr }} 发布]</p>
        <div class="job-wrap">
          <div class="job-wrap-l">
            <div class="job-tit">
              <span class="job-tit-name">{{ jobData.jobName }}</span>
              <span class="job-tit-inner">{{ jobData.salaryAreaStr }}</span>
            </div>
            <p class="job-desc" v-if="jobData.recruitmentTypeStr == '应届'">
              {{ jobData.areaCodeStr }} | {{ jobData.recruitmentTypeStr }} |
              {{ jobData.recruitmentNumber }} ｜
              {{ jobData.educationLevelIdStr }}
            </p>
            <p class="job-desc" v-else>
              {{ jobData.areaCodeStr }} | {{ jobData.recruitmentTypeStr }} |
              {{ jobData.recruitmentNumber }} ｜ {{ jobData.internshipStr }} |
              {{ jobData.delayDayStr }}
            </p>
            <ul class="newjob-welfare">
              <li
                class="newjob-welfare-i"
                v-for="(sonitem, sonindex) in jobData.treatment"
                :key="sonindex"
              >
                {{ sonitem }}
              </li>
            </ul>
          </div>
          <div class="job-wrap-r">
            <div
              class="job-push"
              :class="{ noclick: jobData.isSendResume == 1 }"
              @click="openApply(jobData.isSendResume)"
            >
              <img src="@/assets/img/push.png" class="job-icon" alt="" />{{
                jobData.isSendResume == 1 ? "已投递" : "立即申请"
              }}
            </div>
            <Apply
              :isSendResume="jobData.isSendResume"
              :isShow="isShow"
              @closeWin="closeWin"
              @isSend="isSend"
              :clientId="clientId"
              :jobId="jobId"
            ></Apply>
            <div class="job-share" @click="share">
              <img src="@/assets/img/share.png" class="job-icon" alt="" />
              发送给朋友
              <input type="text" :value="copyValue" id="copy" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <main class="main-wrap">
      <div class="wrap main-con">
        <article class="main">
          <!-- 职位描述 -->
          <p class="main-tit">职位描述</p>
          <div class="job-detail">
            <p>
              {{ jobData.description }}
            </p>
          </div>
          <!-- 职位描述 -->
        </article>
        <aside class="aside">
          <div class="job-company">
            <div class="simil-job-con">
              <div class="simil-job-l">
                <img :src="companyData.logo" alt="" />
              </div>
              <div class="simil-job-r">
                <p class="simil-job-tit">{{ companyData.clientName }}</p>
                <p
                  class="simil-job-link"
                  @click="goCompany(companyData.clientId)"
                >
                  公司主页
                </p>
              </div>
            </div>
            <ul class="job-company-list">
              <li class="job-company-li">
                <img
                  src="@/assets/img/job2.png"
                  class="job-company-icon"
                  alt=""
                />
                {{ companyData.industryStr }}
              </li>
              <li class="job-company-li">
                <img
                  src="@/assets/img/job3.png"
                  class="job-company-icon"
                  alt=""
                />
                {{ companyData.companyScaleIdStr }}
              </li>
              <li class="job-company-li">
                <img
                  src="@/assets/img/job1.png"
                  class="job-company-icon"
                  alt=""
                />
                {{ companyData.companyNatureIdStr }}
              </li>
            </ul>
            <p class="job-company-desc" :class="{ jobAll: isAll }">
              {{ companyData.description }}
            </p>
            <div class="click-all" @click="cliclAll">
              {{ isAll ? "收起" : "展开全部" }}
            </div>
          </div>
          <!-- map str -->
          <div class="job-company-mapwrap">
            <Map
              :markerPoint="markerPoint"
              v-if="hasMap"
              :address="companyData.address"
            ></Map>
          </div>
          <!-- map end -->
          <div v-if="hasData">
            <p class="main-tit">相似职位</p>
            <ul class="simil-job">
              <li
                class="simil-job-item"
                v-for="(item, index) in similarData"
                :key="index"
                @click="goJob(item.jobId, item.clientId)"
              >
                <div class="simil-job-con">
                  <div class="simil-job-l">
                    <img :src="item.logo" alt="" />
                  </div>
                  <div class="simil-job-r">
                    <p class="simil-job-tit">
                      <span>{{ item.jobName }}</span>
                      <span class="salary">{{ item.salaryAreaStr }}</span>
                    </p>
                    <p class="simil-job-desc">
                      <span>{{ item.clientName }} </span>&nbsp;·&nbsp;
                      <span>{{ item.companyNatureIdStr }}</span>
                    </p>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </aside>
      </div>
    </main>
  </div>
</template>
<script>
import Map from "@/components/Map.vue";
import Apply from "@/components/Apply.vue";
import { getJobDetail, getClientList, getSimilarJobList } from "@/api/job.js";

export default {
  components: {
    Map,
    Apply,
  },
  data() {
    return {
      markerPoint: { lng: 116.4, lat: 39.9 },
      jobData: {},
      companyData: {},
      similarData: [],
      isShow: false,
      jobId: "",
      clientId: "",
      copyValue: "",
      hasMap: false,
      hasData: false,
      isAll: false,
    };
  },
  created() {
    this.jobId = this.$route.query.id;
    this.clientId = this.$route.query.clientId;
    this.copyValue = window.location.href;
    this.getJob(this.jobId);
    this.getClient(this.clientId);
  },
  methods: {
    // 职位详情
    getJob(jobId) {
      let data = {
        jobId: jobId,
      };
      getJobDetail(data)
        .then((res) => {
          if (res.success) {
            this.jobData = res.data;
            this.getSimilar(this.jobData.jobId, 3);
          }
        })
        .catch((rej) => {
          console.log(rej);
        });
    },
    // 企业详情
    getClient(clientId) {
      let data = {
        clientId: clientId,
      };
      getClientList(data)
        .then((res) => {
          if (res.success) {
            this.companyData = res.data;
            this.markerPoint.lng = res.data.longitude;
            this.markerPoint.lat = res.data.latitude;
            this.hasMap = true;
          }
        })
        .catch((rej) => {
          console.log(rej);
        });
    },
    // 相似职位
    getSimilar(jobName, pageSize) {
      let data = {
        jobId: jobName,
        pageSize: pageSize,
      };
      getSimilarJobList(data)
        .then((res) => {
          if (res.success) {
            this.similarData = res.data;
            if (res.data.length > 0) {
              this.hasData = true;
            }
          }
        })
        .catch((rej) => {
          console.log(rej);
        });
    },
    goCompany(id) {
      this.$router.push({ path: "/company", query: { id } });
    },
    goJob(id, clientId) {
      this.$router.push({
        path: "/job",
        query: { id: id, clientId: clientId },
      });
    },
    openApply() {
      this.isShow = true;
    },
    closeWin(message) {
      this.isShow = false;
      if (message[0]) {
        this.getJob(this.jobId);
      }
    },
    isSend() {
      this.jobData.isSendResume = 1;
    },
    share() {
      let input = document.getElementById("copy");
      input.select();
      document.execCommand("Copy");
      this.$message.success("复制链接成功");
    },
    cliclAll() {
      this.isAll = !this.isAll;
    },
  },
};
</script>
<style scoped>
#job {
  padding-top: 64px;
}
.wrap {
  width: 1200px;
  margin: 0 auto;
}
.job-top {
  background: #f7f9fc;
  padding: 30px 0 40px;
}
.job-date {
  color: #999;
}
.job-wrap {
  display: flex;
  justify-content: space-between;
}
.job-tit {
  display: flex;
  font-size: 32px;
  line-height: 45px;
  line-height: 38px;
  margin: 12px 0;
}
.job-tit-name {
  max-width: 500px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.job-tit-inner {
  color: #ff6600;
  padding-left: 16px;
  max-width: 320px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.newjob-welfare {
  display: flex;
  flex-wrap: wrap;
  margin: 18px 0 -10px;
}
.newjob-welfare-i {
  background: #e8f4ff;
  border-radius: 2px;
  padding: 4px 15px;
  font-size: 13px;
  color: #3b87ff;
  margin-right: 10px;
  margin-bottom: 10px;
  border-radius: 13px;
}
.main-wrap {
  background: #fff;
}
.main-con {
  display: flex;
  justify-content: space-between;
  padding-top: 35px;
}
.job-push {
  width: 160px;
  height: 46px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #3b87ff;
  border-radius: 3px;
  color: #fff;
  font-size: 16px;
  cursor: pointer;
}
.job-icon {
  width: 16px;
  height: 16px;
  margin-right: 13px;
}
.noclick {
  background: #adcdff;
  cursor: no-drop;
}
.job-share {
  text-align: right;
  margin-top: 17px;
  color: #3b87ff;
  cursor: pointer;
}
.job-share .job-icon {
  margin-right: 5px;
}
.main {
  margin-right: 19px;
  padding-bottom: 50px;
  flex: 1;
}
.aside {
  width: 338px;
  border-left: 1px solid #eeeeee;
}
.main-tit {
  position: relative;
  font-size: 16px;
  font-weight: 500;
  color: #333333;
  line-height: 22px;
  padding-bottom: 13px;
}
.main-tit::after {
  position: absolute;
  content: "";
  bottom: 0;
  left: 0;
  width: 30px;
  height: 2px;
  background: #3b87ff;
}
.job-detail {
  margin: 23px 0;
}
.job-detail p {
  line-height: 30px;
  white-space: pre-wrap;
}
.job-address {
  line-height: 20px;
  margin: 20px 0 13px;
}
.map {
  width: 100%;
  height: 260px;
}
.simil-job {
  margin: 6px 0 60px;
}
.simil-job-item {
  padding-left: 26px;
  cursor: pointer;
}
.simil-job-con {
  display: flex;
  border-bottom: 1px dashed #eeeeee;
  padding-bottom: 16px;
}
.simil-job .simil-job-item {
  padding: 16px 0 0 26px;
}
.simil-job .simil-job-item:hover {
  background: #f9f9f9;
}
.simil-job .simil-job-item:hover .simil-job-tit {
  color: #3b87ff;
}
.simil-job-l {
  flex: 0 0 56px;
  height: 56px;
  border-radius: 4px;
  border: 1px solid #f5f5f5;
  background: #fff;
}
.simil-job-l img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
.simil-job-tit {
  font-size: 16px;
  margin-bottom: 13px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden;
}
.simil-job-desc,
.simil-job .simil-job-tit {
  display: flex;
}
.simil-job-desc,
.simil-job-desc span {
  color: #999;
  line-height: 20px;
}
.simil-job-desc span,
.simil-job-tit span {
  width: 45%;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden;
}
.simil-job-r {
  padding: 5px 14px;
}
.simil-job-tit .salary {
  padding-left: 6px;
  color: #ff6600;
}
.aside .main-tit {
  margin-left: 26px;
}
.job-company {
  border-bottom: 1px solid #eeeeee;
  margin-bottom: 22px;
  margin-left: 26px;
}
.job-company-mapwrap {
  border-bottom: 1px solid #eeeeee;
  padding-bottom: 22px;
  margin-bottom: 22px;
  margin-left: 26px;
}
.simil-job-link {
  color: #3b87ff;
  cursor: pointer;
}
.job-company .simil-job-con {
  border: none;
}
.job-company-li {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}
.job-company-icon {
  margin-right: 11px;
  width: 16px;
  height: 16px;
}
.job-company-desc {
  line-height: 23px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 5;
  overflow: hidden;
}
.jobAll {
  display: block;
}
.click-all {
  cursor: pointer;
  line-height: 23px;
  color: #3b87ff;
  margin: 5px 0 22px;
}
#copy {
  opacity: 0;
  width: 1px;
}
</style>
